import classNames from 'classnames/bind';
import React, { ReactElement } from 'react';
import { NO_DATA } from '../../../Base.constants';
import { Filter, FilterItem } from '../../../models';
import { IssuerDto } from '../../../services/dtos/issuer/issuer.dto';
import { convertToTreeModel } from '../../../utils/filterUtils';
import styles from './CompanyOverview.module.scss';

const cx = classNames.bind(styles);

interface CompanyOverviewSectorsProps {
  filter?: Filter;
  company: IssuerDto;
}

const CompanyOverviewSectors = ({ filter, company }: CompanyOverviewSectorsProps): ReactElement => {
  const sectors = convertToTreeModel({
    options: filter?.options || [],
    filter: (filter: FilterItem) => company.implied.includes(filter.tagId),
  });

  const formatContinuousText = (text: string) => {
    return text.replace('/', '/ ');
  };

  if (!sectors?.length) {
    return (
      <div className={cx('row')} data-testid="metadata-sector">
        <div className={cx('cell')}>Sectors</div>
        <div className={cx('cell')}>{NO_DATA}</div>
      </div>
    );
  }

  return (
    <>
      {sectors.map((sector) => (
        <React.Fragment key={sector.key}>
          <div className={cx('row')} data-testid="metadata-sector">
            <div className={cx('cell')}>Sector</div>
            <div className={cx('cell')}>{formatContinuousText(sector.title)}</div>
          </div>
          {sector.children?.map((subsector) => (
            <div className={cx('row')} data-testid="metadata-subsector" key={subsector.key}>
              <div className={cx('cell')}>Subsector</div>
              <div className={cx('cell')}>{formatContinuousText(subsector.title)}</div>
            </div>
          ))}
        </React.Fragment>
      ))}
    </>
  );
};

export default CompanyOverviewSectors;
